<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{'title.confirm_export_data' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>
  <div style="padding: 10px 10px 20px 10px; font-size: 16px; max-height: 500px; overflow-y: auto;" class="row">
    <div class="!px-0">
      <div style="overflow-wrap: anywhere;" [innerHTML]="getContent() | translate"></div>
      <ng-container *ngIf="data.typeDialog === 'export_customer_compact' || data.typeDialog === 'export_group_customer_compact'">
        <div style="padding: 17px 0 0 0;">({{'messages.note_create_contract_lot' | translate}})</div>
      </ng-container>
      <div style="padding: 17px 0;" [innerHTML]="'messages.note_click_export_data' | translate"></div>
      <div [innerHTML]="'messages.note_click_export_data_and_view' | translate"></div>
    </div>
  </div>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
  
  
  <div mat-dialog-actions class="justify-content-center">
    <button mat-stroked-button color="primary" class="font-weight-bold" type="button" (click)="onNoClick()" cdkFocusInitial [appTrackEvent]="tractContent('huy_bo')">
      <mat-icon class="mr-2">cancel</mat-icon>{{'document_download.cancel' | translate}}
    </button>
    <button class="ml-2 font-weight-bold" mat-raised-button color="primary" type="button" (click)="exportData()" cdkFocusInitial [appTrackEvent]="tractContent('xuat_du_lieu')">
      {{'button.export_data' | translate}}
    </button>
    <button class="ml-2 font-weight-bold" mat-stroked-button color="primary" type="button" (click)="exportDataAndViewResult()" cdkFocusInitial [appTrackEvent]="tractContent('xuatxemkq')">
      {{'button.export_data_and_view_result' | translate}}
    </button>
  </div>
  